export const makeQuery = query => Object.keys(query).map(item => `${ item }=${ encodeURIComponent(query[item]) }`).join('&');

export const isExternal = url => {
  const host = window.location.hostname;
  const getHostname = link => {
    if (!/^https?:\/\//.test(link)) return window.location.hostname;
    const parser = document.createElement('a');
    parser.href = link;
    return parser.hostname;
  };
  return host !== getHostname(url);
};
